/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaximumPaymentPlanLength/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Type from './Type/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MaximumPaymentPlanLength({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/MaximumPaymentPlanLength",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let settingsDataMaximumPaymentPlanLengthValueValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.maximum_payment_plan_length.value',
})
let settingsDataMaximumPaymentPlanLengthValueChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'data.maximum_payment_plan_length.value',
})
  return (<React.Fragment
>
<div
  data-testid="MaximumPaymentPlanLength.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-LxFsQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Maximum payment plan length (months)"
 marginTop={0}
/>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="settings.data.maximum_payment_plan_length.value"
 onChange={settingsDataMaximumPaymentPlanLengthValueChangeData}
 value={settingsDataMaximumPaymentPlanLengthValueValueData}
 type="number"
 marginTop={0}
 flexGrow={0}
 flexBasis="0%"
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 maxWidth={150}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder={0}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
{children}
</React.Fragment>)
}